
import React from 'react';
import { useState, useEffect } from "react";
import { useHistory, useParams } from 'react-router-dom';
import Select from "react-select";
import { toast } from "react-toastify";
import ReceivablesSideBar from "../../ReceviablesSideBar"
import swal from "sweetalert";

import receCss from '../../../../css/ReceivablesRegisterECL.module.css'

import {getAllReceivableECLScenario, selectReceivableECLScenario, getreceviablesMapping, setReceviablesEclFields, recevibalesUserConfirmation,  calculateReceviablesECL, receivableViewWorking, addToReceivablesListing, getReceivablesData } from '../../../../../Bookclosure/Services/ApiHandler'

import  { ReactComponent as PervBtnIcon }  from '../../../../assets/icons/pervECLBtnIcon.svg'
import  { ReactComponent as BreadCrumbsdor }  from '../../../../assets/icons/breadCrumbsDot.svg'
import  { ReactComponent as EditIcon }  from '../../../../assets/icons/editCard.svg'
import  { ReactComponent as CompleteECLIcon }  from '../../../../assets/icons/completeECL.svg'
import  { ReactComponent as Warning }  from '../../../../assets/icons/warningIconLoanRegisterECL.svg'
import  { ReactComponent as RefershIcon }  from '../../../../assets/icons/loanRegisterRefersh.svg'
import  { ReactComponent as LoaderIcon }  from '../../../../assets/icons/loansLoader.svg'

import Table from "../../../../elements/Table"
import  { ReactComponent as NextBtnIcon }  from '../../../../assets/icons/rightWhite.svg'

// Sending Data to Api when user Click on the Next Button

const addLoanToListing = (loanId) => {
    addToReceivablesListing(loanId,'ECL').then(() => {
        toast.success("Successfully Add to Receivables listing.");
    })
}

const LoanRegisterEcl = () => {

    const { id, companyId } = useParams();
    // const [companyID, setcompanyID] = useState(id)
    const [companyID, setcompanyID] = useState('6655b5365ce609ea146c5c53')
    const [receviablesID, setreceviablesID] = useState('685a3dcafd8a703cbc9bff9f')

    // active stage
    const [ActiveStage, setActiveStage] = useState(1)

    const numberofStages = [1, 2, 3, 4, 5, 6, 7]

    // Stage One
    const [stageOneOptions , setStageOneOptions] = useState([])
    const [stageOneScenarioId , setstageOneScenarioId] = useState(stageOneOptions?.[0]?.value)

    useEffect(() => {
        if (stageOneOptions.length > 0) {
            setstageOneScenarioId(stageOneOptions[0].value);
        }
    }, 
    [stageOneOptions]);

    // stage Two
    const [stageTwoOptions , setstageTwoOptions] = useState([])
    const [receivableECLDueDateColumn , setreceivableECLDueDateColumn] = useState()
    const [receivableECLOutstandingColumns , setreceivableECLOutstandingColumns] = useState([])
    const [receivableECLExclusionColumn , setreceivableECLExclusionColumn] = useState()


    // stage Three
    const [stageThreeData , setstageThreeData] = useState()
    const [stageThreeTableHeaders , setstageThreeTableHeaders] = useState([])
    const [stageThreeTableBody , setstageThreeTableBody] = useState([])


    // stage Six
    const [StageSixPostition, setStageSixPostition] = useState(1)
    const [StageSixData, setStageSixData] = useState()
    const [stageSixTableHeaders , setstageSixTableHeaders] = useState([])
    const [stageSixTableBody , setstageSixTableBody] = useState([])


    const computeEcl = () => {
        setStageSixPostition(2); // show loading or computing state

        calculateReceviablesECL(receviablesID)
        .then((res) => {
            const body = res.data;
            setstageSixTableHeaders(body?.ECLHeaders);

            // Convert each object to array of values
            const tableRows = body?.ECLTable?.map(obj => Object.values(obj));
            setstageSixTableBody(tableRows);

            setStageSixPostition(3); // move to final view
        });

    };

    // View Working Data 
    const [viewWorkTab, setviewWorkTab]  = useState(1)
    const [viewWorkPD, setviewWorkPD]  = useState()
    // const [viewWorkLGD, setviewWorkLGD] = useState()
    // const [viewWorkFLF, setviewWorkFLF] = useState()

    useEffect(() => {

        getAllReceivableECLScenario(companyID).then(Response => {
            let listOfScenarios = Response.data.receivableECLScenarioList;

            // Map receivable list to dropdown format
            const formattedOptions = listOfScenarios.map(eachItem => ({
                value: eachItem._id,
                label: eachItem.name
            }));

            setStageOneOptions(formattedOptions);
        });

        // stage two api
        getreceviablesMapping(receviablesID, setreceviablesID).then(Response => {
            let itemsList = Response.data.fields;

            const stageTwoformattedOptions = itemsList?.map(Item => ({
                value: Item,
                label: Item
            }));

            setstageTwoOptions(stageTwoformattedOptions)

        })
        

        // View Working Data
        receivableViewWorking(receviablesID, setreceviablesID).then(Response => {
            let viewWorkingPD = Response.data.PDWorkings;
            setviewWorkPD(viewWorkingPD)
        })

    }, 
    [companyID]);

    useEffect(() => {
        console.log('stageTwoOptions :: ',stageTwoOptions);
    }, [stageTwoOptions])

    // useEffect(() => {

    //     if(stageOneOptions.length > 0 &&  stageTwoOptions.length > 0){

    //         // Pre fill's the data
    //         getReceivablesData(receviablesID).then(Response => {

    //             let secanrioId = Response.data.receivable?.receivableECLScenarioID
    //             setstageOneScenarioId(secanrioId)
    
    //             console.log('secanrioId :: ',secanrioId);
    
    //             setreceivableECLDueDateColumn(Response.data.receivable?.receivableECLDueDateColumn)
    //             console.log('Response.data.receivable?.receivableECLDueDateColumn :: ',Response.data.receivable?.receivableECLDueDateColumn);
    
    //             setreceivableECLOutstandingColumns(Response.data.receivable?.receivableECLOutstandingColumns)
    //             console.log('Response.data.receivable?.receivableECLOutstandingColumns :: ',Response.data.receivable?.receivableECLOutstandingColumns);
    //             // setreceivableECLOutstandingColumns(["CustomerID3", "ApplicantName3", "Product  ID3", "Product name", "LegacyID"])
    
    //             setreceivableECLExclusionColumn(Response.data.receivable?.receivableECLExclusionColumn)
    //             console.log('Response.data.receivable?.receivableECLExclusionColumn :: ',Response.data.receivable?.receivableECLExclusionColumn);
    //         })

    //     }

    // }, [stageOneOptions, stageTwoOptions])

    useEffect(() => {
        if (
            stageOneOptions.length > 0 &&
            stageTwoOptions.length > 0 &&
            receviablesID
        ) {
            getReceivablesData(receviablesID).then(Response => {
            const data = Response.data.receivable;

            setstageOneScenarioId(data?.receivableECLScenarioID || '');
            setreceivableECLDueDateColumn(data?.receivableECLDueDateColumn || '');
            setreceivableECLOutstandingColumns(data?.receivableECLOutstandingColumns || []);
            setreceivableECLExclusionColumn(data?.receivableECLExclusionColumn || '');
            });
        }
    },
    [stageOneOptions, stageTwoOptions, receviablesID]);


    return (
        <div style={{ display: 'flex' }}>
            <ReceivablesSideBar
                id={id}
                companyId={companyId}
                activeTab={'Compute Calculations'}
                subMenuItem={'ECL'}
            />

            <div className={receCss.mainContainer}>

                <EclHeader
                    ActiveStage={ActiveStage}
                    setActiveStage={setActiveStage}
                />

                {numberofStages.includes(ActiveStage) ? (
                        <StageNumberBadge
                            ActiveStage={ActiveStage}
                            setActiveStage={setActiveStage}
                        />
                ) : ''}

                <div className={ numberofStages.includes(ActiveStage) ? receCss.subContainer : receCss.subCatgeoryContainer}>

                    <div className={
                            numberofStages.includes(ActiveStage)
                                ? receCss.stagesContantHoldContainer
                                : receCss.stagesTwoCategoryContantHoldContainerNoMargTp
                            }>

                        {
                            ActiveStage === 1
                            ?
                                <StageOne
                                    stageOneOptions={stageOneOptions}
                                    stageOneScenarioId={stageOneScenarioId}
                                    setstageOneScenarioId={setstageOneScenarioId}
                                />
                            :

                            ActiveStage === 2
                                ?
                                    <StageTwo
                                        stageTwoOptions={stageTwoOptions}
                                        setstageTwoOptions={setstageTwoOptions}
                                        receivableECLDueDateColumn={receivableECLDueDateColumn}
                                        setreceivableECLDueDateColumn={setreceivableECLDueDateColumn}
                                        receivableECLOutstandingColumns={receivableECLOutstandingColumns}
                                        setreceivableECLOutstandingColumns={setreceivableECLOutstandingColumns}
                                        receivableECLExclusionColumn={receivableECLExclusionColumn} 
                                        setreceivableECLExclusionColumn={setreceivableECLExclusionColumn}
                                    />
                                :

                            ActiveStage === 'view' 
                                ? 
                                    <StageSixViewWork 
                                        viewWorkTab={viewWorkTab} 
                                        setviewWorkTab={setviewWorkTab}
                                        stageSixTableHeaders={stageSixTableHeaders}
                                        stageSixTableBody={stageSixTableBody}
                                        viewWorkPD={viewWorkPD}
                                        // viewWorkFLF={viewWorkFLF}
                                    /> 
                                :

                            ActiveStage === 3
                                ? 
                                    <StageThree 
                                        stageThreeTableHeaders={stageThreeTableHeaders}
                                        stageThreeTableBody={stageThreeTableBody}
                                    /> 
                                :

                            ActiveStage === 4
                                ? 
                                    <StageSix
                                        receviablesID={receviablesID}
                                        ActiveStage={ActiveStage}
                                        setActiveStage={setActiveStage}
                                        StageSixPostition={StageSixPostition} 
                                        setStageSixPostition={setStageSixPostition}
                                        computeEcl={computeEcl}
                                        stageSixTableHeaders={stageSixTableHeaders}
                                        stageSixTableBody={stageSixTableBody}
                                    /> 
                                :

                            ActiveStage === 5
                                ? 
                                    <StageSeven /> 
                                :
                            null
                        }

                    </div>

                </div>

                {numberofStages.includes(ActiveStage) ? (
                        <EclFooter
                            ActiveStage={ActiveStage}
                            setActiveStage={setActiveStage}
                            receviablesID={receviablesID}
                            stageOneScenarioId={stageOneScenarioId}
                            receivableECLDueDateColumn={receivableECLDueDateColumn}
                            receivableECLOutstandingColumns={receivableECLOutstandingColumns}
                            receivableECLExclusionColumn={receivableECLExclusionColumn}
                            setstageThreeTableHeaders={setstageThreeTableHeaders}
                            setstageThreeTableBody={setstageThreeTableBody}
                        />
                ) : ''}

            </div>

        </div>
    );
};

export default LoanRegisterEcl;


// const StageNumberBadge = ({
//     ActiveStage,
//     setActiveStage,
//     }) => {

//         var outerBadge1 = `${receCss.numBadge} ${receCss.inactiveBadgeBgClr}`
//         var innerBadge1 = `${receCss.numBadgeInner} ${receCss.innerBadgeBgClr}`
//         var badgeConnecter1 = `${receCss.numbConnterStart2} ${receCss.inactiveBadgeBgClr}`
//         var content1 = 1

//         var outerBadge2 = `${receCss.numBadge} ${receCss.inactiveBadgeBgClr}`
//         var innerBadge2 = `${receCss.numBadgeInner} ${receCss.innerBadgeBgClr}`
//         var badgeConnecter2 = `${receCss.numbConnterStart2} ${receCss.inactiveBadgeBgClr}`
//         var content2 = 2

//         var outerBadge5 = `${receCss.numBadge} ${receCss.inactiveBadgeBgClr}`
//         var innerBadge5 = `${receCss.numBadgeInner} ${receCss.innerBadgeBgClr}`
//         var badgeConnecter5 = `${receCss.numbConnterStart5} ${receCss.inactiveBadgeBgClr}`
//         var content5 = 3

//         var outerBadge6 = `${receCss.numBadge} ${receCss.inactiveBadgeBgClr}`
//         var innerBadge6 = `${receCss.numBadgeInner} ${receCss.innerBadgeBgClr}`
//         var badgeConnecter6 = `${receCss.numbConnterStart6} ${receCss.inactiveBadgeBgClr}`
//         var content6 = 4

//         var outerBadge7 = `${receCss.numBadge} ${receCss.inactiveBadgeBgClr}`
//         var innerBadge7 = `${receCss.numBadgeInner} ${receCss.innerBadgeBgClr}`
//         var badgeConnecter7 = `${receCss.numbConnterStart7} ${receCss.inactiveBadgeBgClr}`
//         var content7 = 5

//         if (ActiveStage === 1) {
//                 outerBadge1 = `${receCss.numBadge} ${receCss.activeBadegClr}`;
//                 innerBadge1 = `${receCss.numBadgeInner} ${receCss.innerBadgeBgClr}`
//                 badgeConnecter1 = `${receCss.numbConnterStart1} ${receCss.activeBadgeBgClr}`
//                 content1 = 1
//             }
//             else if (ActiveStage === 2) {
//                 outerBadge1 = `${receCss.numBadge} ${receCss.completeBadgeClr}`;
//                 innerBadge1 = `${receCss.numBadgeInner} ${receCss.completeBadgeClr}`
//                 badgeConnecter1 = `${receCss.numbConnterStart1} ${receCss.completedBadgConnecterClr}`
//                 content1 = <CompleteECLIcon />

//                 outerBadge2 =  `${receCss.numBadge} ${receCss.activeBadegClr}`
//                 innerBadge2 = `${receCss.numBadgeInner} ${receCss.innerBadgeBgClr}`
//                 badgeConnecter2 = `${receCss.numbConnterStart2} ${receCss.activeBadgeBgClr}`
//             }
         
//             else if (ActiveStage === 3) {
//                 outerBadge1 = `${receCss.numBadge} ${receCss.completeBadgeClr}`;
//                 innerBadge1 = `${receCss.numBadgeInner} ${receCss.completeBadgeClr}`
//                 badgeConnecter1 = `${receCss.numbConnterStart1} ${receCss.fullCompletedBadgConnecterClr}`
//                 content1 = <CompleteECLIcon />

//                 outerBadge2 =  `${receCss.numBadge} ${receCss.completeBadgeClr}`
//                 innerBadge2 = `${receCss.numBadgeInner} ${receCss.completeBadgeClr}`
//                 badgeConnecter2 = `${receCss.numbConnterStart2} ${receCss.fullCompletedBadgConnecterClr}`
//                 content2 = <CompleteECLIcon />

//                 outerBadge5 = `${receCss.numBadge} ${receCss.activeBadegClr}`
//                 innerBadge5 = `${receCss.numBadgeInner} ${receCss.innerBadgeBgClr}`
//                 badgeConnecter5 = `${receCss.numbConnterStart5} ${receCss.activeBadgeBgClr}`
//             }
//             else if (ActiveStage === 4) {
//                 outerBadge1 = `${receCss.numBadge} ${receCss.completeBadgeClr}`;
//                 innerBadge1 = `${receCss.numBadgeInner} ${receCss.completeBadgeClr}`
//                 badgeConnecter1 = `${receCss.numbConnterStart1} ${receCss.fullCompletedBadgConnecterClr}`
//                 content1 = <CompleteECLIcon />

//                 outerBadge2 =  `${receCss.numBadge} ${receCss.completeBadgeClr}`
//                 innerBadge2 = `${receCss.numBadgeInner} ${receCss.completeBadgeClr}`
//                 badgeConnecter2 = `${receCss.numbConnterStart2} ${receCss.fullCompletedBadgConnecterClr}`
//                 content2 = <CompleteECLIcon />

//                 outerBadge5 = `${receCss.numBadge} ${receCss.completeBadgeClr}`
//                 innerBadge5 = `${receCss.numBadgeInner} ${receCss.completeBadgeClr}`
//                 badgeConnecter5 = `${receCss.numbConnterStart5} ${receCss.completedBadgConnecterClr}`
//                 content5 = <CompleteECLIcon />

//                 outerBadge6 = `${receCss.numBadge} ${receCss.activeBadegClr}`
//                 innerBadge6 = `${receCss.numBadgeInner} ${receCss.innerBadgeBgClr}`
//                 badgeConnecter6 = `${receCss.numbConnterStart6} ${receCss.activeBadgeBgClr}`
//             }
//             else if (ActiveStage === 5) {
//                 outerBadge1 = `${receCss.numBadge} ${receCss.completeBadgeClr}`;
//                 innerBadge1 = `${receCss.numBadgeInner} ${receCss.completeBadgeClr}`
//                 badgeConnecter1 = `${receCss.numbConnterStart1} ${receCss.fullCompletedBadgConnecterClr}`
//                 content1 = <CompleteECLIcon />

//                 outerBadge2 =  `${receCss.numBadge} ${receCss.completeBadgeClr}`
//                 innerBadge2 = `${receCss.numBadgeInner} ${receCss.completeBadgeClr}`
//                 badgeConnecter2 = `${receCss.numbConnterStart2} ${receCss.fullCompletedBadgConnecterClr}`
//                 content2 = <CompleteECLIcon />

//                 outerBadge5 = `${receCss.numBadge} ${receCss.completeBadgeClr}`
//                 innerBadge5 = `${receCss.numBadgeInner} ${receCss.completeBadgeClr}`
//                 badgeConnecter5 = `${receCss.numbConnterStart5} ${receCss.fullCompletedBadgConnecterClr}`
//                 content5 = <CompleteECLIcon />

//                 outerBadge6 = `${receCss.numBadge} ${receCss.completeBadgeClr}`
//                 innerBadge6 = `${receCss.numBadgeInner} ${receCss.completeBadgeClr}`
//                 badgeConnecter6 = `${receCss.numbConnterStart6} ${receCss.completedBadgConnecterClr}`
//                 content6 = <CompleteECLIcon />

//                 outerBadge7 = `${receCss.numBadge} ${receCss.activeBadegClr}`
//                 innerBadge7 = `${receCss.numBadgeInner} ${receCss.innerBadgeBgClr}`
//                 badgeConnecter7 = `${receCss.numbConnterStart7} ${receCss.activeBadgeBgClr}`
//             }

//     return (

//         <div className={receCss.numBadgeMainContainer}>
//             <div className={receCss.numberContainer}>
//                 <div onClick={ () => {} } key={1} className={outerBadge1}>
//                     <div className={badgeConnecter1}></div>
//                     <div className={innerBadge1}>{content1}</div>
//                     <div className={`${receCss.numberText} ${receCss.numberText1}`}>Scenario</div>
//                 </div>
//                 <div onClick={ () => {} } key={2} className={outerBadge2}>
//                     <div className={badgeConnecter2}></div>
//                     <div className={innerBadge2}>{content2}</div>
//                     <div className={`${receCss.numberText} ${receCss.numberText2}`}>confirm fields</div>
//                 </div>
//                 <div onClick={ () => {} } key={3} className={outerBadge5}>
//                     <div className={badgeConnecter5}></div>
//                     <div className={innerBadge5}>{content5}</div>
//                     <div className={`${receCss.numberText} ${receCss.numberText5}`}>user confirmation</div>
//                 </div>
//                 <div onClick={ () => {} } key={4} className={outerBadge6}>
//                     <div className={badgeConnecter6}></div>
//                     <div className={innerBadge6}>{content6}</div>
//                     <div className={`${receCss.numberText} ${receCss.numberText6}`}>compute Ecl</div>
//                 </div>
//                 <div onClick={ () => {} } key={5} className={outerBadge7}>
//                     <div className={badgeConnecter7}></div>
//                     <div className={innerBadge7}>{content7}</div>
//                     <div className={`${receCss.numberText} ${receCss.numberText7}`}>pass ecl entries</div>
//                 </div>
//             </div>
//         </div>
//     );
// };



const StageNumberBadge = ({
    ActiveStage,
    setActiveStage,
}) => {

    // === DEFAULT CLASSES ===
    let outerBadge1 = `${receCss.numBadge} ${receCss.inactiveBadgeBgClr} ${receCss.badge}`;
    let innerBadge1 = `${receCss.numBadgeInner} ${receCss.innerBadgeBgClr}`;
    let badgeConnecter1 = `${receCss.numbConnterStart1} ${receCss.inactiveBadgeBgClr}`;
    let content1 = 1;

    let outerBadge2 = `${receCss.numBadge} ${receCss.inactiveBadgeBgClr} ${receCss.badge}`;
    let innerBadge2 = `${receCss.numBadgeInner} ${receCss.innerBadgeBgClr}`;
    let badgeConnecter2 = `${receCss.numbConnterStart2} ${receCss.inactiveBadgeBgClr}`;
    let content2 = 2;

    let outerBadge3 = `${receCss.numBadge} ${receCss.inactiveBadgeBgClr} ${receCss.badge}`;
    let innerBadge3 = `${receCss.numBadgeInner} ${receCss.innerBadgeBgClr}`;
    let badgeConnecter3 = `${receCss.numbConnterStart3} ${receCss.inactiveBadgeBgClr}`;
    let content3 = 3;

    let outerBadge4 = `${receCss.numBadge} ${receCss.inactiveBadgeBgClr} ${receCss.badge}`;
    let innerBadge4 = `${receCss.numBadgeInner} ${receCss.innerBadgeBgClr}`;
    let badgeConnecter4 = `${receCss.numbConnterStart4} ${receCss.inactiveBadgeBgClr}`;
    let content4 = 4;

    let outerBadge5 = `${receCss.numBadge} ${receCss.inactiveBadgeBgClr} ${receCss.badge}`;
    let innerBadge5 = `${receCss.numBadgeInner} ${receCss.innerBadgeBgClr}`;
    let badgeConnecter5 = `${receCss.numbConnterStart5} ${receCss.inactiveBadgeBgClr}`;
    let content5 = 5;

    if (ActiveStage === 1) {
        outerBadge1 = `${receCss.numBadge} ${receCss.activeBadegClr} ${receCss.badge}`;
        badgeConnecter1 = `${receCss.numbConnterStart1} ${receCss.middleActiveBar}`;

        badgeConnecter2 = `${receCss.numbConnterStart2} ${receCss.lastInActiverBar}`;
    } else if (ActiveStage === 2) {
        outerBadge1 = `${receCss.numBadge} ${receCss.completeBadgeClr} ${receCss.badge}`;
        innerBadge1 = `${receCss.numBadgeInner} ${receCss.completeBadgeClr}`;
        badgeConnecter1 = `${receCss.numbConnterStart1} ${receCss.completedBadgConnecterClr}`;
        content1 = <CompleteECLIcon />;

        outerBadge2 = `${receCss.numBadge} ${receCss.activeBadegClr} ${receCss.badge}`;
        badgeConnecter2 = `${receCss.numbConnterStart2} ${receCss.middleActiveBar}`;

        badgeConnecter3 = `${receCss.numbConnterStart3} ${receCss.lastInActiverBar}`;
    } else if (ActiveStage === 3) {
        outerBadge1 = `${receCss.numBadge} ${receCss.completeBadgeClr} ${receCss.badge}`;
        innerBadge1 = `${receCss.numBadgeInner} ${receCss.completeBadgeClr}`;
        badgeConnecter1 = `${receCss.numbConnterStart1} ${receCss.fullCompletedBadgConnecterClr}`;
        content1 = <CompleteECLIcon />;

        outerBadge2 = `${receCss.numBadge} ${receCss.completeBadgeClr} ${receCss.badge}`;
        innerBadge2 = `${receCss.numBadgeInner} ${receCss.completeBadgeClr}`;
        badgeConnecter2 = `${receCss.numbConnterStart2} ${receCss.completedBadgConnecterClr}`;
        content2 = <CompleteECLIcon />;

        outerBadge3 = `${receCss.numBadge} ${receCss.activeBadegClr} ${receCss.badge}`;
        badgeConnecter3 = `${receCss.numbConnterStart3} ${receCss.middleActiveBar}`;

        badgeConnecter4 = `${receCss.numbConnterStart4} ${receCss.lastInActiverBar}`;
    } else if (ActiveStage === 4) {
        outerBadge1 = `${receCss.numBadge} ${receCss.completeBadgeClr} ${receCss.badge}`;
        innerBadge1 = `${receCss.numBadgeInner} ${receCss.completeBadgeClr}`;
        badgeConnecter1 = `${receCss.numbConnterStart1} ${receCss.fullCompletedBadgConnecterClr}`;
        content1 = <CompleteECLIcon />;

        outerBadge2 = `${receCss.numBadge} ${receCss.completeBadgeClr} ${receCss.badge}`;
        innerBadge2 = `${receCss.numBadgeInner} ${receCss.completeBadgeClr}`;
        badgeConnecter2 = `${receCss.numbConnterStart2} ${receCss.fullCompletedBadgConnecterClr}`;
        content2 = <CompleteECLIcon />;

        outerBadge3 = `${receCss.numBadge} ${receCss.completeBadgeClr} ${receCss.badge}`;
        innerBadge3 = `${receCss.numBadgeInner} ${receCss.completeBadgeClr}`;
        badgeConnecter3 = `${receCss.numbConnterStart3} ${receCss.completedBadgConnecterClr}`;
        content3 = <CompleteECLIcon />;

        outerBadge4 = `${receCss.numBadge} ${receCss.activeBadegClr} ${receCss.badge}`;
        badgeConnecter4 = `${receCss.numbConnterStart4} ${receCss.middleActiveBar}`;

        badgeConnecter5 = `${receCss.numbConnterStart5} ${receCss.lastInActiverBar}`;
    } else if (ActiveStage === 5) {
        outerBadge1 = `${receCss.numBadge} ${receCss.completeBadgeClr} ${receCss.badge}`;
        innerBadge1 = `${receCss.numBadgeInner} ${receCss.completeBadgeClr}`;
        badgeConnecter1 = `${receCss.numbConnterStart1} ${receCss.fullCompletedBadgConnecterClr}`;
        content1 = <CompleteECLIcon />;

        outerBadge2 = `${receCss.numBadge} ${receCss.completeBadgeClr} ${receCss.badge}`;
        innerBadge2 = `${receCss.numBadgeInner} ${receCss.completeBadgeClr}`;
        badgeConnecter2 = `${receCss.numbConnterStart2} ${receCss.fullCompletedBadgConnecterClr}`;
        content2 = <CompleteECLIcon />;

        outerBadge3 = `${receCss.numBadge} ${receCss.completeBadgeClr} ${receCss.badge}`;
        innerBadge3 = `${receCss.numBadgeInner} ${receCss.completeBadgeClr}`;
        badgeConnecter3 = `${receCss.numbConnterStart3} ${receCss.fullCompletedBadgConnecterClr}`;
        content3 = <CompleteECLIcon />;

        outerBadge4 = `${receCss.numBadge} ${receCss.completeBadgeClr} ${receCss.badge}`;
        innerBadge4 = `${receCss.numBadgeInner} ${receCss.completeBadgeClr}`;
        badgeConnecter4 = `${receCss.numbConnterStart4} ${receCss.completedBadgConnecterClr}`;
        content4 = <CompleteECLIcon />;

        outerBadge5 = `${receCss.numBadge} ${receCss.activeBadegClr} ${receCss.badge}`;
        badgeConnecter5 = `${receCss.numbConnterStart5} ${receCss.middleActiveBar}`;
    }

    return (
        <div className={receCss.numBadgeMainContainer}>
            <div className={receCss.numberContainer}>
                <div onClick={() => {}} key={1} className={`${receCss.numBadgeContainer} ${receCss.badgeContainerOne}`} style={{ width: 'calc(11%)' }}>
                    <div className={badgeConnecter1}></div>
                    <div className={`${outerBadge1} ${receCss.badge}`}>
                        <div className={innerBadge1}>{content1}</div>
                    </div>
                    <div className={`${receCss.numberText} ${receCss.numberText1}`}>Scenario</div>
                </div>
                <div onClick={() => {}} key={2} className={`${receCss.numBadgeContainer} ${receCss.badgeContainerTwo}`}>
                    <div className={badgeConnecter2}></div>
                    <div className={`${outerBadge2} ${receCss.badge}`}>
                        <div className={innerBadge2}>{content2}</div>
                    </div>
                    <div className={`${receCss.numberText} ${receCss.numberText2}`}>confirm fields</div>
                </div>
                <div onClick={() => {}} key={3} className={`${receCss.numBadgeContainer} ${receCss.badgeContainerThree}`}>
                    <div className={badgeConnecter3}></div>
                    <div className={`${outerBadge3} ${receCss.badge}`}>
                        <div className={innerBadge3}>{content3}</div>
                    </div>
                    <div className={`${receCss.numberText} ${receCss.numberText3}`}>user confirmation</div>
                </div>
                <div onClick={() => {}} key={4} className={`${receCss.numBadgeContainer} ${receCss.badgeContainerFour}`}>
                    <div className={badgeConnecter4}></div>
                    <div className={`${outerBadge4} ${receCss.badge}`}>
                        <div className={innerBadge4}>{content4}</div>
                    </div>
                    <div className={`${receCss.numberText} ${receCss.numberText4}`}>compute Ecl</div>
                </div>
                <div onClick={() => {}} key={5} className={`${receCss.numBadgeContainer} ${receCss.badgeContainerFive}`} style={{ width: 'calc(11%)' }}>
                    <div className={badgeConnecter5}></div>
                    <div className={`${outerBadge5} ${receCss.badge}`}>
                        <div className={innerBadge5}>{content5}</div>
                    </div>
                    <div className={`${receCss.numberText} ${receCss.numberText5}`}>pass ecl entries</div>
                </div>
            </div>
        </div>
    );
};



const StageOne = ({
    stageOneOptions,
    stageOneScenarioId,
    setstageOneScenarioId
}) => {

    return(
        <div className={receCss.stage1MainContainer}>
            <div className={receCss.stage1SubContainer}>

                <div>
                    <span className={receCss.scenarioLabelClr}>Scenario</span>
                    <div className={receCss.editPolicyContainer}>
                        <Select
                            components={{ IndicatorSeparator: () => null }}
                            value={stageOneOptions.find(opt => opt.value === stageOneScenarioId)}
                            onChange={(selectedOption) => setstageOneScenarioId(selectedOption.value)}
                            options={stageOneOptions}
                            // options={stageOneOptions}
                            placeholder="Select Scenario"
                            name="status"
                            className={`mt-0 ${receCss.scenarioSelect}`}
                            classNamePrefix="select"
                            styles={customStyles}
                            isClearable={false}
                            isSearchable={false}
                        />
                        <div className={receCss.stageOneEditScenarioContainer}>
                            <span>
                                <EditIcon className={receCss.scenarioEditIcon} />
                            </span>
                            <span className={receCss.customGreenText}>
                                Edit in Policies
                            </span>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    )

}


const StageTwo = ({
    stageTwoOptions,
    receivableECLDueDateColumn,
    setreceivableECLDueDateColumn,
    receivableECLOutstandingColumns,
    setreceivableECLOutstandingColumns,
    receivableECLExclusionColumn , 
    setreceivableECLExclusionColumn,
}) => {

    return(
        <div className={receCss.stageTwoMainContainer}>
            <div style={{ width: '100%' }}>
                <div className={receCss.stageTwoInptWarapper}>
                    <div className={receCss.stageTwoSubContainer}>
                        <div className={receCss.stageTwoStageSelectContainer}>
                            <span className={`${receCss.scenarioLabelClr} ${receCss.mb10}`}>Due Date</span>
                            <Select
                                components={{ IndicatorSeparator: () => null }}
                                defaultValue={stageTwoOptions?.[0]}
                                onChange={(selectedOption) => setreceivableECLDueDateColumn(selectedOption.value)}
                                value={stageTwoOptions?.find(opt => opt.value === receivableECLDueDateColumn) || stageTwoOptions?.[0]}
                                options={stageTwoOptions}
                                placeholder="Select Scenario"
                                name="status"
                                className={`mt-0 ${receCss.StageTwoSelect}`}
                                classNamePrefix="select"
                                styles={customStyles}
                                isClearable={false}
                                isSearchable={false}
                            />
                            <span className={receCss.stageTwoInptDesc}>Note or description for particular field</span>
                        </div>
                    </div>
                    <div className={receCss.stageTwoSubContainer}>
                        <div className={receCss.stageTwoStageSelectContainer}>
                            <span className={`${receCss.scenarioLabelClr} ${receCss.mb10}`}>Outstanding Loan Amount</span>
                            {/* <Select
                                components={{ IndicatorSeparator: () => null }}
                                defaultValue={stageTwoOptions?.[0]}
                                onChange={(selectedOption) => {
                                    setreceivableECLOutstandingColumns(prev => {
                                        const newValue = selectedOption.value;
                                        return prev.includes(newValue) ? prev : [...prev, newValue];
                                    });
                                }}
                                // value={stageTwoOptions?.find(opt => opt.value === receivableECLOutstandingColumns?.[0]) || stageTwoOptions?.[0]}
                                value={stageTwoOptions?.filter(opt => receivableECLOutstandingColumns?.includes(opt.value))}

                                options={stageTwoOptions}
                                placeholder="Select Scenario"
                                name="status"
                                className={`mt-0 ${receCss.StageTwoSelect}`}
                                classNamePrefix="select"
                                styles={customStyles}
                                isClearable={false}
                                isSearchable={false}
                                isMulti={true}
                            /> */}

                            {/* <Select
                                components={{ IndicatorSeparator: () => null }}
                                defaultValue={stageTwoOptions?.[0]}
                                onChange={(selectedOptions) => {
                                    const newValues = selectedOptions.map(opt => opt.value);
                                    setreceivableECLOutstandingColumns(newValues);
                                }}
                                value={stageTwoOptions?.filter(opt => receivableECLOutstandingColumns?.includes(opt.value))}
                                // value={stageTwoOptions.filter(opt => receivableECLOutstandingColumns.includes(opt.value))}
                                options={stageTwoOptions}
                                placeholder="Select Scenario"
                                name="status"
                                className={`mt-0 ${receCss.StageTwoSelect} ${receCss.customSelectHeight}`}
                                classNamePrefix="select"
                                isMulti={true}
                                styles={customStyles}
                                isClearable={false}
                                isSearchable={false}
                            /> */}


                            <Select
                                components={{ IndicatorSeparator: () => null }}
                                defaultValue={stageTwoOptions?.[0]}
                                onChange={(selectedOptions) => {
                                    const newValues = selectedOptions?.map(opt => opt.value) || [];
                                    setreceivableECLOutstandingColumns(newValues);
                                }}
                                value={stageTwoOptions?.filter(opt => receivableECLOutstandingColumns?.includes(opt.value))}
                                options={stageTwoOptions}
                                placeholder="Select Scenario"
                                name="status"
                                className={`mt-0 ${receCss.StageTwoSelect} ${receCss.customSelectHeight}`}
                                classNamePrefix="select"
                                isMulti={true}
                                styles={customStyles}
                                isClearable={false}
                                isSearchable={false}
                            />
                            <span className={receCss.stageTwoInptDesc}>Note or description for particular field</span>
                        </div>
                    </div>
                </div>

                <div className={receCss.stageTwoInptWarapper} style={{ marginTop: '20px' }}>
                    <div className={receCss.stageTwoSubContainer}>
                        <div className={receCss.stageTwoStageSelectContainer}>
                            <span className={`${receCss.scenarioLabelClr} ${receCss.mb10}`}>Further Exclusions</span>
                            <Select
                                components={{ IndicatorSeparator: () => null }}
                                defaultValue={stageTwoOptions?.[0]}
                                onChange={(selectedOption) => setreceivableECLExclusionColumn(selectedOption.value)}
                                // value={stageTwoOptions?.find(opt => opt.value === receivableECLExclusionColumn?.[0]) || stageTwoOptions?.[0]}
                                value={receivableECLExclusionColumn ? stageTwoOptions?.find(opt => opt.value === receivableECLExclusionColumn) : stageTwoOptions?.[0]}

                                options={stageTwoOptions}
                                placeholder="Select Scenario"
                                name="status"
                                className={`mt-0 ${receCss.StageTwoSelect}`}
                                classNamePrefix="select"
                                styles={customStyles}
                                isClearable={false}
                                isSearchable={false}
                            />
                            <span className={receCss.stageTwoInptDesc}>Note or description for particular field</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )

}


const StageThree = ({
    stageThreeTableHeaders,
    stageThreeTableBody
}) => {
    return (
        <div className={receCss.stageThreeMainContainer}>
            <div className={receCss.stageThreeTableLabel}>
                Lorem ipsum dolor sit, amet consectetur adipisicing elit. Soluta, facere.
            </div>

            {/* NEW WRAPPER */}
            <div className={receCss.stageThreeScrollWrapper}>
                <div className={receCss.stageThreeTable}>
                    <div className={receCss.stageThreeTableHeader}>
                        {stageThreeTableHeaders.map((header, index) => (
                            <div key={index} className={receCss.stageThreeTableHeaderItem}>
                                {header}
                            </div>
                        ))}
                    </div>

                    <div className={receCss.stageThreeTableBody}>
                        {stageThreeTableBody.map((row, rowIndex) => (
                            <div className={receCss.stageThreeTableBodyRow} key={rowIndex}>
                                {Object.values(row).map((cell, cellIndex) => (
                                    <div key={`${rowIndex}-${cellIndex}`} className={receCss.stageThreeTableBodyItem}>
                                        {cell === 'Yes' ? (
                                            <input type="checkbox" checked readOnly />
                                        ) : cell === 'No' ? (
                                            <input type="checkbox" readOnly />
                                        ) : cell === 'Warning' ? (
                                            <div><Warning />&nbsp;Warning</div>
                                        ) : (
                                            cell
                                        )}
                                    </div>
                                ))}
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}



const StageSix = ({
    receviablesID,
    ActiveStage,
    setActiveStage,
    StageSixPostition, 
    setStageSixPostition,
    computeEcl,
    stageSixTableHeaders,
    stageSixTableBody
    }) => {

    const StageSixStartCompute = () =>{
        return(
            <div className={receCss.computeMainContainer}>
                <div className={receCss.computeContainer}>
                    <div className={receCss.computText}>Lorem ipsum dolor sit amet consectetur.</div>
                    <div className={receCss.computText}>Lorem ipsum dolor sit amet.</div>
                    <div>
                        <button type="button"
                            style={{ marginTop:'10px' }} className={`${receCss.stageSixBtn} ${receCss.stageSixPrimaryBtn}`}
                            onClick={() => {computeEcl()}}
                        >Compute ECL</button> </div>
                </div>
            </div>
        )
    }

    const StageSixLoader = () => {
        return(
            <div className={receCss.computeMainContainer}>
                <div className={receCss.computeContainerLoader}>
                    <LoaderIcon className={receCss.spininfinite} />
                    <div className={receCss.computText}>Computation in progress</div>
                    <div className={receCss.computText}>This might take a few minutes, Please wait...</div>
                </div>
            </div>
        )
    }

    const StageSixDataView = () => {
        return(
            <div className={receCss.stageSixMainContainer}>
                <div className={receCss.stageSixbtnContainer}>
                    <div className={receCss.stageSixbtnLeftContainer}>
                        <button style={{ marginRight : '10px' }} type="button" className={`${receCss.stageSixbtnBorderRadius} ${receCss.stageSixBtn} ${receCss.stageSixSecondaryBtn}`}> <RefershIcon /> Refresh</button>
                        <button className={`${receCss.stageSixbtnBorderRadius} ${receCss.stageSixBtn} ${receCss.stageSixSecondaryBtn}`} type="button">Start Over</button>
                    </div>
                    <div className={receCss.stageSixbtnRightContainer}>
                        <button type="button"
                            className={`${receCss.stageSixbtnBorderRadius} ${receCss.stageSixBtn} ${receCss.stageSixSecondaryBtn}`}
                            onClick={() => { setActiveStage('view') }}
                        >View Workings</button>
                        <button 
                            style={{ marginLeft : '10px' }} 
                            type="button" 
                            className={`${receCss.stageSixbtnBorderRadius} ${receCss.stageSixBtn} ${receCss.stageSixPrimaryBtn}`}
                            onClick={() => addLoanToListing(receviablesID)}
                            >Add columns to receivable listing</button>
                    </div>
                </div>
                <div className={receCss.stageThreeScrollWrapper}>
                    <div className={receCss.stageThreeTable}>
                        <div className={receCss.stageThreeTableHeader}>
                            {stageSixTableHeaders?.map((header, index) => (
                                <div key={index} className={receCss.stageThreeTableHeaderItem}>
                                    {header}
                                </div>
                            ))}
                        </div>

                        <div className={receCss.stageSixTableBody}>
                            {stageSixTableBody?.map((row, rowIndex) => (
                                <React.Fragment >
                                    <div className={receCss.stageThreeTableBodyRow} key={`${rowIndex}`}>
                                        {row.map((cell, cellIndex) => (
                                            <div key={`${rowIndex}-${cellIndex}`} className={receCss.stageThreeTableBodyItem}>
                                                {cell}
                                            </div>
                                        ))}
                                    </div>
                                </React.Fragment>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    return(
        <React.Fragment>
            {StageSixPostition === 1 && <StageSixStartCompute />}
            {StageSixPostition === 2 && <StageSixLoader />}
            {StageSixPostition === 3 && <StageSixDataView />}
        </React.Fragment>
    )

}


const StageSeven = () => {

    return(
        <div className={receCss.stageSevenMainContainer}>
            <div className={receCss.stageSevenOutStandContainer}>
                <div className={receCss.stageSevenLoansOutstandLabel}>
                    Lorem ipsum dolor sit amet.
                </div>
                <div className={receCss.stageSevenLoanDataCont}>
                    <div className={receCss.stageSeveOutStandingDataItem}>
                        <div className={receCss.stageSevenlabel}>
                            Loan Outstanding (Gross)
                        </div>
                        <div>
                            97,84,653
                        </div>
                    </div>
                    <div className={receCss.stageSeveOutStandingDataItem}>
                        <div className={receCss.stageSevenlabel}>
                            ECL Amount
                        </div>
                        <div>
                            87,84,653
                        </div>
                    </div>

                    <div className={receCss.stageSeveoutStandSubCont}>
                        <div className={receCss.stageSeveOutStandingDataItem}>
                            <div className={receCss.stageSevenlabel}>
                                ECL as per Ledger
                            </div>
                            <div>
                                <input className={receCss.stageSevenInpt} type="text" name="" id="" placeholder='Enter Amount...' />
                            </div>
                        </div>

                        <div className={receCss.stageSeveOutStandingDataItem}>
                            <div className={receCss.stageSevenlabel}>
                                Amount to be passed
                            </div>
                            <div>
                                87,84,653
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className={`${receCss.stageSevenOutStandContainer} ${receCss.mT25}`}>
                <div className={receCss.stageSevenLoansOutstandLabel}>
                      Suggested Entry
                </div>
                <div className={receCss.stageSevenLoanDataCont}>
                    <div className={receCss.stageSeveOutStandingDataItem}>
                        <div className={receCss.stageSevenlabel}>
                            Provision for ECL
                        </div>
                        <div>
                            97,84,653
                        </div>
                    </div>
                    <div className={receCss.stageSeveOutStandingDataItem}>
                        <div className={receCss.stageSevenlabel}>
                            To Expected credit loss account - Loans
                        </div>
                        <div>
                            87,84,653
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )

}





const StageSixViewWork = ({
    stageSixTableHeaders,
    stageSixTableBody,
    viewWorkPD,
    viewWorkTab, 
    setviewWorkTab,
    // viewWorkLGD,
    // viewWorkFLF,
}) => {
   

    return(

        <div>
            <div className={receCss.catgegoryContainer}>
                <div className={ viewWorkTab == 1 ? receCss.activeCategoryTab : receCss.inActiveCategoryTab} onClick={() => {setviewWorkTab(1)}}>
                    Ageing Table
                </div>
                {/* <div className={ viewWorkTab == 2 ? receCss.activeCategoryTabNoRadius : receCss.inActiveCategoryTab} onClick={() => {setviewWorkTab(2)}}>
                    LGD
                </div>
                <div className={ viewWorkTab == 3 ? receCss.activeCategoryTabNoRadius : receCss.inActiveCategoryTab} onClick={() => {setviewWorkTab(3)}}>
                    FLF
                </div> */}
            </div>

            <div className={receCss.viewWorkContainer}>

                {
                
                    viewWorkTab === 1 
                        ? 
                            <div className={receCss.tablesContainerViewWork}>

                                {viewWorkPD?.map((tableObj, tableIndex) => (
                                    <div key={tableIndex} className={receCss.stageThreeScrollWrapper}>
                                        {/* Title */}
                                        <div className={`${receCss.stageThreeTableTitle} ${receCss.TableName}`}>
                                            {tableObj?.tableTitle}
                                        </div>
                                        <div className={receCss.stageThreeTable}>
                                            {/* Headers */}
                                            <div className={receCss.stageThreeTableHeader}>
                                                {tableObj?.tableHeaders.map((header, index) => (
                                                    <div key={index} className={receCss.stageThreeTableHeaderItem}>
                                                        {header}
                                                    </div>
                                                ))}
                                            </div>
                                            {/* Body */}
                                            <div className={receCss.stageViewWork}>
                                                {tableObj?.table.map((rowObj, rowIndex) => (
                                                    <div key={rowIndex} className={receCss.stageThreeTableBodyRow}>
                                                        {tableObj?.tableHeaders.map((header, cellIndex) => (
                                                            <div key={`${rowIndex}-${cellIndex}`} className={receCss.stageThreeTableBodyItem}>
                                                                {rowObj[header]}
                                                            </div>
                                                        ))}
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        :       
                   
                        ''
                }

            </div>

        </div>
    )

}


const EclHeader = ({
    ActiveStage,
    setActiveStage
    }) => {
    return(
        <div className={receCss.headerContainer}>
            <div className={receCss.eclbreadCumbs}
                onClick={() => {
                    if (ActiveStage === 'view') {
                        setActiveStage(4);
                    }
                }}
                >
                <PervBtnIcon />
            </div>
            <div className={receCss.headerBreadCrumbsText}>
                Receivables
            </div>
            <div className={receCss.breadCumbContainer}>
                <BreadCrumbsdor />
            </div>
            <div className={`${receCss.headerBreadCrumbsText} ${receCss.semiboldLabel}`}>
                ECL
            </div>
        </div>
    )
}


const EclFooter = ({

    ActiveStage,
    setActiveStage,

    receviablesID,
    stageOneScenarioId,

    receivableECLDueDateColumn,
    receivableECLOutstandingColumns,
    receivableECLExclusionColumn,
    setstageThreeTableHeaders,
    setstageThreeTableBody

    }) => {

    const routerHistory = useHistory();
    const handleClick = (Link) => {
        routerHistory.push(Link);
    };

    return(
        <div className={receCss.footerContainer}>
            <div>
                <button
                onClick={() => {handleClick('/myfinv2/company-edit/accounting-policy/10')}}
                className={receCss.cancelBtn} type="button">Cancel</button>
            </div>
            <div className={receCss.footerbtnContainer}>
                <button 
                    onClick={() => {
                        if (ActiveStage !== 1) {
                            setActiveStage(ActiveStage - 1);
                        }
                    }}
                    className={receCss.perviewBtn} 
                    type="button"> 
                    <PervBtnIcon />  
                    Previous
                </button>
                <button 
                    onClick={()=>{
                        if(ActiveStage !== 5){ 

                            if(ActiveStage === 1){
                                selectReceivableECLScenario(receviablesID,stageOneScenarioId)
                            }
                            if(ActiveStage === 2){
                                let stageTwoDataObj = {
                                    // Required: Name of the field in your dataset that represents the receivable due date
                                    "receivableECLDueDateColumn": receivableECLDueDateColumn,
                                    // Required min 1: List of field names that represent receivable outstanding amounts
                                    "receivableECLOutstandingColumns":  receivableECLOutstandingColumns,
                                    // Required: Name of the field in your dataset that represents the receivable exclusion
                                    "receivableECLExclusionColumn": receivableECLExclusionColumn
                                }
                                setReceviablesEclFields(receviablesID, stageTwoDataObj).then(() => {
                                    recevibalesUserConfirmation(receviablesID).then(Response => {
                                        const headers = Response?.data?.PDHeaders || [];
                                        const body = Response?.data?.PDTable || [];

                                        if (headers.length > 0 && body.length > 0) {
                                            setstageThreeTableHeaders(headers);
                                            setstageThreeTableBody(body);
                                        }
                                    });
                                })
                            }
                            setActiveStage(ActiveStage + 1)
                        }
                    }}
                    className={receCss.saveBtn} 
                    type="button">
                        { ActiveStage === 7 ? 'Finish' : 'Next'}<NextBtnIcon/>
                    </button>
            </div>
        </div>
    )
}


export const customStyles = {
  control: (provided, state) => ({
    ...provided,
    backgroundColor: '#f4faf5',
    borderColor: '#c2e6d1',
    color: '#b3c0bd',
    boxShadow: state.isFocused ? '0 0 0 1px #c2e6d1' : 'none',
    borderWidth: '1px',
    borderRadius: '10px',
    '&:hover': {
      borderColor: '#b3c0bd',
    },
    minHeight: 'max-content',
    height: 'max-content',
  }),
  valueContainer: (provided) => ({
    ...provided,
    padding: '2px 8px',
    paddingTop: '1px',
  }),
  input: (provided) => ({
    ...provided,
    color: '#b3c0bd',
  }),
  placeholder: (provided) => ({
    ...provided,
    color: '#b3c0bd',
    fontSize: '14px',
  }),
  singleValue: (provided) => ({
    ...provided,
    color: '#4d6d64',
    fontSize: '14px',
  }),
  multiValue: (provided) => ({
    ...provided,
    backgroundColor: '#e0f5e9',
    borderRadius: '0.25rem',
    border: '1px solid #c2e6d1',
    width: 'fit-content',
  }),
  multiValueLabel: (provided) => ({
    ...provided,
    color: '#4d6d64',
  }),
  multiValueRemove: (provided) => ({
    ...provided,
    color: '#b3c0bd',
    ':hover': {
      backgroundColor: '#c2e6d1',
      color: '#4f665f',
    },
  }),
  indicatorsContainer: (provided) => ({
    ...provided,
    color: '#b3c0bd',
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    color: '#205a46', 
    ':hover': {
        color: '#205a46',
    },
    }),
  clearIndicator: (provided) => ({
    ...provided,
    color: '#b3c0bd',
    ':hover': {
      color: '#4f665f',
    },
  }),
  menu: (provided) => ({
    ...provided,
    backgroundColor: '#ffffff',
    border: '1px solid #c2e6d1',
    borderRadius: '10px',
    boxShadow: '0 0 0 1px #c2e6d1',
    marginTop: '6px',
    zIndex: 10,
  }),
  menuList: (provided) => ({
    ...provided,
    padding: '4px',
    borderRadius: '10px',
  }),
//   option: (provided, state) => ({
//     ...provided,
//     backgroundColor: state.isSelected
//       ? '#c2e6d1'
//       : state.isFocused
//       ? '#f4faf5'
//       : 'transparent',
//     color: '#4f665f',
//     padding: '10px 12px',
//     cursor: 'pointer',
//     fontSize: '14px',
//     borderRadius: '8px',
//     // margin: '4px 6px',
//   }),
option: (provided, state) => ({
  ...provided,
  backgroundColor: state.isFocused
    ? '#f4faf5'
    : 'transparent',
  color: '#4f665f',
  padding: '10px 12px',
  cursor: 'pointer',
  fontSize: '14px',
  borderRadius: '8px',
}),

  noOptionsMessage: (provided) => ({
    ...provided,
    color: '#b3c0bd',
    padding: '8px 12px',
  }),
};
